function init() {
    const sliders = document.querySelectorAll("[data-card-slider='icons-row']");
    const largeSliders = document.querySelectorAll(
        "[data-card-slider='icons-row-large']",
    );

    const slickOptions = {
        dots: true,
        infinite: true,
        speed: 1000,
        centerMode: false,
        arrows: false,
        autoplay: false,
        rows: 0,
    };

    sliders.forEach((slider) => {
        console.log(jQuery(slider));

        jQuery(slider).slick({
            ...slickOptions,
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: false,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        speed: 2500,
                    },
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: false,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        speed: 2500,
                    },
                },
            ],
        });
    });

    largeSliders.forEach((slider) => {
        jQuery(slider).slick({
            ...slickOptions,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    });
}

document.addEventListener("DOMContentLoaded", init);
